module.exports = __webpack_public_path__ + "_assets/img/chevron-01.54ab1bd3.svg";